
import FAQ5 from "../components/FAQ5";
import Footer from "../components/Footer";
import Header from "../components/Header";

function Connecticut() {
  const cityName = "Connecticut";
  const state = "CT";
  const areaName = "Connecticut State";
  
  return (
    <>
    <section 
      className="relative w-full min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] bg-cover bg-center"
      style={{
        backgroundImage: "url('blog13.png')",
      }}
    >
      <Header/>

      {/* Hero Content */}
      <div className="relative z-20 flex items-center justify-center min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] px-4">
        <div className="max-w-5xl text-center text-white">
          <h1 className="font-bold leading-snug text-white">
            Local Connecticut Limo Services by Majestic Voyage NYC
          </h1>
          <div className="mt-6 flex justify-center gap-2 text-sm font-medium">
            <a href="/" className="hover:text-logo-green">Home</a>
            <span>/</span>
            <a href="/cities" className="hover:text-logo-green">Areas We Serve</a>
            <span>/</span>
            <span className="text-logo-green">Connecticut Limo Services</span>
          </div>
        </div>
      </div>
    </section>

    {/* Main Content Section */}
    <section className="bg-white py-12 sm:py-16 px-4 sm:px-6 lg:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-[65%_35%] gap-8 sm:gap-12">
          {/* Left Side - Main Content */}
          <div>
            <h1 className="font-bold text-gray-900 mb-3 sm:mb-4 leading-tight">
              Connecticut Limo Services
            </h1>
            <p className="text-gray-600 mb-3 sm:mb-3">
              Serving all of {cityName} and the {areaName} area
            </p>
            <p className="text-gray-900 mb-4 sm:mb-6 leading-relaxed">
              Majestic Voyage NYC provides trusted and professional Connecticut limo services for airport transfers, corporate travel, and private transportation. We serve clients across Connecticut with a strong focus on punctual service, luxury vehicles, and experienced chauffeurs. Our local limo service in Connecticut is ideal for residents, business travelers, and visitors who want safe and comfortable transportation to major airports and cities.
            </p>
            
            <h2 className="font-bold text-gray-900 mb-3 sm:mb-4 leading-tight">
              Local Service Areas in Connecticut
            </h2>
            <p className="text-gray-900 mb-4 sm:mb-6 leading-relaxed">
              Majestic Voyage NYC proudly offers limo service across all major Connecticut locations, including:
            </p>
            <ul className="space-y-2 sm:space-y-3 mb-6 sm:mb-8">
              <li className="text-gray-900">• Fairfield County</li>
              <li className="text-gray-900">• Stamford</li>
              <li className="text-gray-900">• Greenwich</li>
              <li className="text-gray-900">• Norwalk</li>
              <li className="text-gray-900">• Fairfield</li>
              <li className="text-gray-900">• Westport</li>
              <li className="text-gray-900">• New Haven</li>
              <li className="text-gray-900">• Bridgeport</li>
              <li className="text-gray-900">• Darien</li>
            </ul>
            <p className="text-gray-900 mb-4 sm:mb-6 leading-relaxed">
              We understand local routes, traffic patterns, and airport timing, which helps us provide reliable transportation every day.
            </p>
            
            <h2 className="font-bold text-gray-900 mb-3 sm:mb-4 leading-tight">
              Limo Service Connecticut for Airport Transportation
            </h2>
            <p className="text-gray-900 mb-4 sm:mb-6 leading-relaxed">
              Our limo service, which Connecticut clients trust, is designed for smooth airport travel. We provide door-to-door pickups with real-time flight tracking to ensure timely arrivals and departures.
            </p>
            <p className="text-gray-900 mb-2 font-semibold">
              Airports we serve locally include:
            </p>
            <ul className="space-y-2 sm:space-y-3 mb-6 sm:mb-8">
              <li className="text-gray-900">• JFK Airport</li>
              <li className="text-gray-900">• LaGuardia Airport</li>
              <li className="text-gray-900">• Newark Airport</li>
              <li className="text-gray-900">• Bradley International Airport</li>
            </ul>
            <p className="text-gray-900 mb-4 sm:mb-6 leading-relaxed">
              Whether you are traveling for business or leisure, Majestic Voyage NYC ensures stress-free airport transportation.
            </p>
            
            <h2 className="font-bold text-gray-900 mb-3 sm:mb-4 leading-tight">
              Connecticut Limousine Service to JFK Airport
            </h2>
            <p className="text-gray-900 mb-4 sm:mb-6 leading-relaxed">
              Majestic Voyage NYC specializes in Connecticut limousine service to JFK for individuals, families, and corporate clients. Our chauffeurs plan the best routes from Connecticut to New York to avoid delays and ensure comfort. This service is popular in Fairfield County and surrounding areas where travelers need dependable long-distance airport transportation.
            </p>
            
            <h2 className="font-bold text-gray-900 mb-3 sm:mb-4 leading-tight">
              Car Service to JFK from CT
            </h2>
            <p className="text-gray-900 mb-4 sm:mb-6 leading-relaxed">
              For clients who prefer a private and executive ride, our car service to JFK from CT is an excellent option. Choose from luxury sedans or SUVs for a quiet and comfortable journey. This service is ideal for early morning flights, late night arrivals, and business professionals who value privacy.
            </p>
            
            <h2 className="font-bold text-gray-900 mb-3 sm:mb-4 leading-tight">
              Fairfield Limo CT Services
            </h2>
            <p className="text-gray-900 mb-4 sm:mb-6 leading-relaxed">
              Majestic Voyage NYC offers dedicated Fairfield limo CT services for airport transfers, weddings, corporate events, and special occasions. We serve both residential and commercial clients across Fairfield County. Local Fairfield residents choose us for our reliability, clean vehicles, and professional drivers.
            </p>
          </div>

          {/* Right Side - Why Choose Us */}
          <div>
            <h2 className="text-xl sm:text-2xl lg:text-2xl font-bold text-gray-900 mb-4 sm:mb-6">
              Why Choose Majestic Voyage NYC?
            </h2>
            <ul className="space-y-3 sm:space-y-4">
              <li className="flex items-start hover:bg-gray-50 p-3 rounded-lg transition-all duration-300 cursor-pointer hover:translate-x-2">
                <span className="text-logo-green mr-3 mt-1 text-xl transition-colors duration-300">✓</span>
                <span className="text-base text-gray-900 font-semibold">Locally focused Connecticut limo services</span>
              </li>
              <li className="flex items-start hover:bg-gray-50 p-3 rounded-lg transition-all duration-300 cursor-pointer hover:translate-x-2">
                <span className="text-logo-green mr-3 mt-1 text-xl transition-colors duration-300">✓</span>
                <span className="text-base text-gray-900 font-semibold">Experienced and licensed chauffeurs</span>
              </li>
              <li className="flex items-start hover:bg-gray-50 p-3 rounded-lg transition-all duration-300 cursor-pointer hover:translate-x-2">
                <span className="text-logo-green mr-3 mt-1 text-xl transition-colors duration-300">✓</span>
                <span className="text-base text-gray-900 font-semibold">Luxury and well-maintained vehicles</span>
              </li>
              <li className="flex items-start hover:bg-gray-50 p-3 rounded-lg transition-all duration-300 cursor-pointer hover:translate-x-2">
                <span className="text-logo-green mr-3 mt-1 text-xl transition-colors duration-300">✓</span>
                <span className="text-base text-gray-900 font-semibold">On-time pickup and drop off</span>
              </li>
              <li className="flex items-start hover:bg-gray-50 p-3 rounded-lg transition-all duration-300 cursor-pointer hover:translate-x-2">
                <span className="text-logo-green mr-3 mt-1 text-xl transition-colors duration-300">✓</span>
                <span className="text-base text-gray-900 font-semibold">24-hour booking support</span>
              </li>
              <li className="flex items-start hover:bg-gray-50 p-3 rounded-lg transition-all duration-300 cursor-pointer hover:translate-x-2">
                <span className="text-logo-green mr-3 mt-1 text-xl transition-colors duration-300">✓</span>
                <span className="text-base text-gray-900 font-semibold">Real-time flight tracking</span>
              </li>
              <li className="flex items-start hover:bg-gray-50 p-3 rounded-lg transition-all duration-300 cursor-pointer hover:translate-x-2">
                <span className="text-logo-green mr-3 mt-1 text-xl transition-colors duration-300">✓</span>
                <span className="text-base text-gray-900 font-semibold">Door-to-door service</span>
              </li>
            </ul>
            
            <div className="mt-8 p-4 bg-blue-50 rounded-lg border border-blue-100">
              <h3 className="font-bold text-gray-900 mb-2">Local Business Trust and Reliability</h3>
              <p className="text-gray-700 mb-4">
                Majestic Voyage NYC is committed to serving the Connecticut community with professional limo and car services. We focus on customer satisfaction, safety, and reliable scheduling for every ride. Whether you need a short local trip or long-distance airport travel, our team is ready to assist.
              </p>
            </div>
            
            <div className="mt-6 sm:mt-8 flex flex-col sm:flex-row gap-4">
              <a href="/booknow" className="bg-blue-600 text-white px-6 sm:px-8 py-3 font-semibold hover:bg-blue-700 transition-colors text-center">
                BOOK YOUR RIDE
              </a>
              <a href="tel:+17182004140" className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center">
                CALL US NOW
              </a>
            </div>
            
            {/* Image below Why Choose section */}
            <div className="mt-8 sm:mt-10">
              <img 
                src="/may1.webp" 
                alt="Luxury Vehicle - Mercedes Maybach" 
                className="w-full h-auto rounded-lg shadow-lg object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Service Areas & Map Section */}
    <section className="bg-white px-4 sm:px-6 mb-4 lg:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-[70%_30%] gap-8 sm:gap-12">
          {/* Left Side - Text Content */}
          <div>
            <h2 className="font-bold text-gray-900 mb-4 sm:mb-6">
              Connecticut Limo Services for Every Occasion
            </h2>
            <p className="text-gray-900 mb-4 sm:mb-6 leading-relaxed">
              Our goal is to build long-term trust with local clients through consistent quality service. We provide luxury transportation solutions for:
            </p>
            <ul className="space-y-2 sm:space-y-3 mb-6 sm:mb-8">
              <li className="text-gray-900">• Airport transfers to JFK, LaGuardia, Newark, and Bradley International</li>
              <li className="text-gray-900">• Corporate travel and business meetings</li>
              <li className="text-gray-900">• Wedding transportation and bridal parties</li>
              <li className="text-gray-900">• Special events and celebrations</li>
              <li className="text-gray-900">• Night out and entertainment venues</li>
              <li className="text-gray-900">• Sports events and concerts</li>
              <li className="text-gray-900">• Prom and graduation events</li>
            </ul>
            
            <div className="bg-gray-50 p-6 rounded-lg mb-6">
              <h3 className="font-bold text-gray-900 mb-3">Call to Action</h3>
              <p className="text-gray-900 mb-4">
                Book your Connecticut limo service today with Majestic Voyage NYC and experience premium local transportation. Contact us now for quick booking and reliable service across Connecticut.
              </p>
              <a href="/booknow" className="inline-block bg-blue-600 text-white px-6 py-3 font-semibold hover:bg-blue-700 transition-colors rounded-lg">
                GET A FREE QUOTE
              </a>
            </div>
          </div>

          {/* Right Side - Map */}
          <div>
            <div className="w-full h-[400px] sm:h-[500px] bg-gray-200 rounded-lg overflow-hidden">
              <iframe
                src={`https://www.google.com/maps?q=${encodeURIComponent(cityName)}+${state}&output=embed`}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title={`${cityName} Location Map`}
              ></iframe>
            </div>
            <div className="mt-4 text-center">
              <p className="text-gray-600 text-sm">
                Serving all of Connecticut including Fairfield County, Stamford, Greenwich, Norwalk, and surrounding areas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Fleet Selection Section - Dark Background */}
    <section className="bg-gray-900 py-16 sm:py-20 px-4 sm:px-6 lg:px-10 relative overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <img 
          src="blog12.png" 
          alt="Fleet Background" 
          className="w-full h-full object-cover"
        />
      </div>
      <div className="relative z-10 max-w-[1200px] mx-auto text-center">
        <h2 className="font-bold text-white mb-4 sm:mb-6">
          Premium Vehicles for Connecticut Limo Services
        </h2>
        <p className="text-white mb-6 sm:mb-8 max-w-3xl mx-auto">
          Choose from our fleet of luxury sedans, SUVs, limousines, and executive vehicles for your Connecticut transportation needs. All vehicles are regularly maintained and equipped with modern amenities for your comfort.
        </p>
        <a 
          href="/fleet" 
          className="inline-block bg-white text-black border-2 border-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors rounded-lg"
        >
          VIEW OUR FLEET
        </a>
      </div>
    </section>

    <FAQ5/>

    <Footer/>
    </>
  );
}

export default Connecticut;
